import React from 'react';
import { QrScanCollectorModal } from '@/common/QrScan';

/**
 * Drum bulk-filter scan modal.
 *
 * Same external API as the original: visible / onCancel / onApply(labels).
 * UI/feedback is the shared gold-standard scan experience.
 */
const BulkScanFilterModal = ({ visible, onCancel, onApply }) => (
  <QrScanCollectorModal
    visible={visible}
    onCancel={onCancel}
    onApply={onApply}
    title="Scan to Filter Drums"
    description="Scan drum QR codes to build a filter. The table will show only the scanned drums."
    noun={{ singular: 'drum', plural: 'drums' }}
    manualPlaceholder="Type drum label (e.g. D-123)"
    applyButtonText="Apply Filter"
  />
);

export default BulkScanFilterModal;
